import { render, staticRenderFns } from "./SignSaleModal.vue?vue&type=template&id=2f547070"
import script from "./SignSaleModal.vue?vue&type=script&lang=ts"
export * from "./SignSaleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f547070')) {
      api.createRecord('2f547070', component.options)
    } else {
      api.reload('2f547070', component.options)
    }
    module.hot.accept("./SignSaleModal.vue?vue&type=template&id=2f547070", function () {
      api.rerender('2f547070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/client-portal/SignSaleModal.vue"
export default component.exports